import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "insurerCode",
  initialState: {
    isInsurer: [],
    isInsurerModalOpen: false,
    onSuccessMessage: {},
    insurerFailedMessage: null,
    isSingleInsurerObj: {},
    isAdding: false,
    isAdded: false,
    isDelete: false,
  },

  reducers: {
    // GET Request
    allInsurerCodeReceived: (insurerCode, action) => {
      insurerCode.isInsurer = action.payload;
    },
    insurerObjectNull: (insurerCode, action) => {
      insurerCode.isSingleInsurerObj = {};
    },
    insurerMessageNull: (insurerCode, action) => {
      insurerCode.onSuccessMessage = {};
    },
    createInsurerModalOpened: (insurerCode, action) => {
      insurerCode.isInsurerModalOpen = true;
      insurerCode.insurerFailedMessage = null;
      insurerCode.isAdded = false;
      insurerCode.onSuccessMessage = {};
    },
    createInsurerModalClosed: (insurerCode, action) => {
      insurerCode.isInsurerModalOpen = false;
      insurerCode.insurerFailedMessage = null;
    },
    insurerAdding: (insurerCode, action) => {
      insurerCode.isAdding = true;
    },
    insurerAdded: (insurerCode, action) => {
      insurerCode.isAdding = false;
      insurerCode.isAdded = true;
      insurerCode.onSuccessMessage = action.payload;
    },
    updateSingleInsurerObject: (insurerCode, action) => {
      insurerCode.isSingleInsurerObj = action.payload;
    },
    insurerDeletedSuccess: (insurerCode, action) => {
      insurerCode.isDelete = true;
    },
    insurerStartSuccess: (insurerCode, action) => {
      insurerCode.isDelete = true;
    },
    insurerAddingFailed: (insurerCode, action) => {
      insurerCode.insurerFailedMessage = action.payload;
    },
  },
});

export const {
  allInsurerCode,
  createInsurerModalOpened,
  createInsurerModalClosed,
  allInsurerCodeReceived,
  insurerAdding,
  insurerAdded,
  updateSingleInsurerObject,
  insurerObjectNull,
  insurerDeletedSuccess,
  insurerStartSuccess,
  insurerMessageNull,
  insurerAddingFailed,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllInsurerList = (type) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code?type=" + type,
    method: "get",
    onSuccess: allInsurerCodeReceived.type,
  });

export const addNewInsurerDetail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code",
    method: "post",
    data: data,
    onStart: insurerAdding.type,
    onSuccess: insurerAdded.type,
    onError: insurerAddingFailed.type,
  });

export const getDeleteInsurer = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code",
    method: "delete",
    data: data,
    onStart: insurerStartSuccess.type,
    onSuccess: insurerDeletedSuccess.type,
  });
// Selector
export const getInsurerListData = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.isInsurer.data
);

export const getInsurerModalOpen = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.isInsurerModalOpen
);
export const getSelectedInsurerObj = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.isSingleInsurerObj
);

export const getInsurerSuccess = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.onSuccessMessage
);

export const isDeletingInsurer = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.isDelete
);
export const isInsurerAdded = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.isAdded
);
export const getInsurerFailed = createSelector(
  (state) => state.entities.insurerCode,
  (insurerCode) => insurerCode.insurerFailedMessage
);
